'use client'

import { useState } from 'react'

import { AnimatePresence, motion } from 'motion/react'
import { Button } from '../Button'

const DropdownMenuVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,

    transition: {
      staggerChildren: 0.05,
    },
  },
}

export const DropdownMenu = ({ label, className = '', children }) => {
  const [expanded, setExpanded] = useState(false)

  const mouseEnter = (e) => {
    setExpanded(true)
  }

  const mouseLeave = (e) => {
    setExpanded(false)
  }

  return (
    <motion.div
      className="relative p-4"
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}
      layout
    >
      <Button
        as="button"
        className={`py-[10px] ${className}`}
        onFocus={mouseEnter}
        onBlur={mouseLeave}
        aria-expanded={expanded}
        aria-controls={`${label}-dropdown-menu`}
      >
        {label}
      </Button>
      <AnimatePresence mode="wait">
        {expanded ? (
          <div
            key="dropdown-menu"
            id={`${label}-dropdown-menu`}
            className={`absolute left-[6px]`}
          >
            <motion.div
              className="background-blur relative mt-8 overflow-hidden rounded-8 p-4"
              layoutId="dropdown-menu-content"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{
                duration: 0.3,
                ease: [0.4, 0, 0.2, 1],
              }}
            >
              <motion.ul layout="position">{children}</motion.ul>
            </motion.div>
          </div>
        ) : null}
      </AnimatePresence>
    </motion.div>
  )
}
